import { observer } from "mobx-react"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"

import PPBadge from "@/component/PPBadge"
import { CROSS_SELL_POINT_ENUM } from "@/enums/CrossSellPoint"
import Api from "@/pages/DeliveryGuarantee/Api"
import { InsurancePointType } from "@/pages/DeliveryGuarantee/Api/type"
import stores from "@/stores"

interface ToProtectionProps {
  pointType?: InsurancePointType
  needCheckShipment?:boolean
  CrossSellTrackerPoint: CROSS_SELL_POINT_ENUM
}
const ToProtection = (props: ToProtectionProps) => {
  const { pointType, needCheckShipment = false, CrossSellTrackerPoint } = props
  const { userInfoSore } = stores
  const { is_pi_eligible, is_pi_active, has_exception_shipment } = userInfoSore.data
  const isPass = is_pi_eligible && !is_pi_active
  const isShow =  needCheckShipment ? (isPass && has_exception_shipment) : isPass
  const navigate = useNavigate()
  const { t } = useTranslation("common")

  if (!isShow) return null
  const handleClick = () => {
    if (pointType){
      Api.postPoint({
        point_type: pointType,
      })
    }

    window.CrossSellTracker?.logClicked(CrossSellTrackerPoint)
    // 跳转PP insurance前，将traceId存储到sessionStorage，避免刷新后丢失
    sessionStorage.setItem("crossSellToInsuranceTraceId", window.CrossSellTracker?.getTraceId() || "")

    navigate({
      pathname: "/protection",
    })
  }

  return (
    <div className="inline-block group cursor-pointer">
      <PPBadge onClick={handleClick}>{t("GetProtection")}</PPBadge>
    </div>
  )
}

export default observer(ToProtection)
